export function ScheduleDashSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/schedule-dash.svg'"></ng-include>`
    }
}
            